import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ParentsMapComponent } from './parents-map/parents-map.component';

const routes: Routes = [{ path: '', component: ParentsMapComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapRoutingModule {}
